import React, { useEffect } from 'react';

import Head from '../../components/head/component'
import {
  Section, 
  SectionTitle, 
  SectionContent,
  Home,
 } from './style'
 import {
  PracticeAreaComponent
 } from '../../components/PracticeArea/components'
 import {
  IntroductingComponents
 } from '../../components/Introducing/components'
 import {
  StayInformedComponent
 } from '../../components/stayinformed/components'
 import {
  Footer
 } from '../../components/footer/components'
import NavigationBar from '../../components/navbar/component'
import CoverImage from '../../home.png';
import { useTranslation } from 'react-i18next';


function App() {
  const { t } = useTranslation('common');
  useEffect(() => {
  }, []);

  return (
    <Home>
      <NavigationBar />
      <Head
        imagePath={CoverImage}
        caption={t('home.heroCaption') || 'YOUR SUPREME LEGAL PROTECTION'}
        addFullGrey={false}
        />
      <Section>
        <SectionTitle>
          {t('home.aboutTitle') || 'About Sequoia Advocates'}
        </SectionTitle>
        <SectionContent>
          {t('home.aboutBody') || `Founded in 2021, Sequoia Advocates has been dedicated 
          to providing exceptional legal services with integrity 
          and expertise. Over the years, we have earned numerous 
          awards, reflecting our commitment to excellence and client 
          success. We continually strive to protect and empower 
          individuals and businesses with reliable legal solutions, 
          ensuring justice and peace of mind for those we serve.`}
        </SectionContent>
      </Section>
      <PracticeAreaComponent />
      <IntroductingComponents />
      <StayInformedComponent />
      <Footer />
    </Home>
  );
}

export default App;
